import React from "react";
import { Stack, Typography } from "@mui/material";

import EmptyImage from "assets/bcba_dashboar_empty_section.png";

const EmptyCancellations = () => {
  return (
    <Stack alignItems="center" textAlign="center" my={5} data-testid="empty-cancellations">
      <img src={EmptyImage} height={223} alt="Empty cancellations" />
      <Typography variant="subtitle1">Stay in the loop as you schedule therapy hours.</Typography>
      <Typography variant="body2" color="text.secondary" data-testid="empty-cancellations-text">
        When cancellations and no-shows happen, they&apos;ll appear here.
      </Typography>
    </Stack>
  );
};

export default EmptyCancellations;
